// Captures the non-auth JetFile launch params (theme, hideback): stores them in
// sessionStorage and strips them from the URL like the token. Must run pre-bootstrap.
export function captureLaunchParams(): void {
    const url = new URL(window.location.href);
    let mutated = false;

    const theme = url.searchParams.get('theme');
    if (theme) {
        sessionStorage.setItem('jf-theme', theme);
    }
    const hideback = url.searchParams.get('hideback') ?? url.searchParams.get('hideBack');
    if (hideback) {
        sessionStorage.setItem('jf-hideback', hideback);
    }
    for (const p of ['theme', 'hideback', 'hideBack']) {
        if (url.searchParams.has(p)) {
            url.searchParams.delete(p);
            mutated = true;
        }
    }
    if (mutated) {
        window.history.replaceState({}, document.title, url.toString());
    }

    const active = sessionStorage.getItem('jf-theme');
    if (active) {
        const safe = /^[\w.-]+/.exec(active.trim())?.[0]?.replace('.', '-');
        try {
            if (safe) document.body.classList.add(safe);
        } catch {
            /* never block app start over a theme class */
        }
    }
}

export function isBackHidden(): boolean {
    return sessionStorage.getItem('jf-hideback') === 'true';
}

export function isNightTheme(): boolean {
    return sessionStorage.getItem('jf-theme') === 'jetfiletech.night';
}
